import { CommunityExpertise } from '@uplift/types';
import { restClient } from '../client';

export type GetCommunityExpertiseGeneralResponse = {
  data: CommunityExpertise[];
};

export const getCommunityExpertiseGeneral = async () => {
  return await restClient.request<GetCommunityExpertiseGeneralResponse>('/api/v1/community_expertise_general');
};
